import { Component } from '@angular/core';

@Component({
  selector: 'app-icon-report',
  imports: [],
  templateUrl: './icon-report.component.html',
  styleUrl: './icon-report.component.scss'
})
export class IconReportComponent {

}
